(function () {
  // Set a variable for our button element.
  const scrollToTopButton = document.getElementById('scrolltop');
  const eBook = document.getElementById('eBook');

  if (!eBook) {
    const scrollFunc = () => {
      // Get the current scroll value
      let y = window.scrollY;
      if (y > 500) {
        scrollToTopButton.className =
          'top-link show animate-[bounce_1s_ease-in-out_2] ';
      } else {
        scrollToTopButton.className = 'top-link hide';
      }
    };

    window.addEventListener('scroll', scrollFunc);

    const scrollToTop = () => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    };

    // When the button is clicked, run our ScrolltoTop function above!
    if (scrollToTopButton) {
      scrollToTopButton.onclick = function (e) {
        e.preventDefault();
        scrollToTop();
      };
    }
  }
})();
